export default {
  breakLarge: "1024px",
  breakMedium: "960px",
  breakSmall: "768px",
  breakTiny: "480px",
}
